// Desktop quick PIN sign-in: device secrets live behind the OS keychain (Electron main process).
import api from './api';

const bridge = () => (typeof window !== 'undefined' ? window.pharmxai : null);
export const quickSigninSupported = () => !!bridge()?.getQuickSignins;

export const listQuickSignins = async () => {
  if (!quickSigninSupported()) return [];
  try { return (await bridge().getQuickSignins()) || []; } catch { return []; }
};

const save = (list) => bridge().setQuickSignins(list);

export const removeQuickSignin = async (credId) => {
  const list = await listQuickSignins();
  const entry = list.find((c) => c.cred_id === credId);
  await save(list.filter((c) => c.cred_id !== credId));
  if (entry) api.post('/auth/quick-signin/forget', { cred_id: entry.cred_id, secret: entry.secret }).catch(() => {});
};

// Called right after a password sign-in: (re)enrol this person on this computer if they have a PIN.
export const enrollQuickSignin = async (userData) => {
  if (!quickSigninSupported() || !userData?.pin_set) return;
  try {
    const { data } = await api.post('/auth/quick-signin/enroll');
    const list = (await listQuickSignins()).filter((c) => c.email?.toLowerCase() !== data.email?.toLowerCase());
    await save([{ cred_id: data.cred_id, secret: data.secret, name: data.name, email: data.email }, ...list].slice(0, 12));
  } catch { /* quick sign-in is a convenience — never block the password sign-in */ }
};
